import { render, staticRenderFns } from "./ReviewRequest.vue?vue&type=template&id=7576a98c&scoped=true&"
import script from "./ReviewRequest.vue?vue&type=script&lang=js&"
export * from "./ReviewRequest.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequest.vue?vue&type=style&index=0&id=7576a98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576a98c",
  null
  
)

export default component.exports